import React, { useMemo } from 'react';
import { SivaCompanyDetailDto, SivaContractDetailDto, SivaContractPhaseDto, SivaPhase } from 'src/api/v2';
import IdeaChangePhaseForm from '../../components/idea/IdeaChangePhaseForm';
import PreIncWithoutCompanyForm from '../../components/company/PreIncWithoutCompanyForm';
import CompanyPhaseChangeForm from '../../components/company/CompanyPhaseChangeForm';
import { useSelfDeclaration } from 'src/features/siva/reporting/hooks/useSelfDeclaration';

type Props = {
  contract: SivaContractDetailDto;
  currentPhase: SivaContractPhaseDto;
  selectedPhase: SivaPhase;
  company?: SivaCompanyDetailDto;
  onCancel: () => void;
};

const EditPhaseFormDisplay: React.FC<Props> = ({
  contract,
  currentPhase,
  selectedPhase,
  company,
  onCancel,
}) => {
  const { data, upsertDto } = useSelfDeclaration(new Date().getFullYear());
  const selfDeclarationDto = useMemo(
    () => data?.find((dto) => dto.organizationNumber === company?.organizationNumber),
    [company?.organizationNumber, data],
  );
  if (!selectedPhase) return <></>;
  if (contract && currentPhase.sivaPhase === SivaPhase.Idea) {
    return (
      <IdeaChangePhaseForm
        contract={contract}
        selectedPhase={selectedPhase}
        company={company ? company : undefined}
        onCancel={onCancel}
        selfDeclarationDto={selfDeclarationDto}
        declarationUpsertDto={upsertDto}
      />
    );
  }
  if (contract && currentPhase.sivaPhase === SivaPhase.PreIncubation && !company) {
    return <PreIncWithoutCompanyForm contract={contract} selectedPhase={selectedPhase} onCancel={onCancel} />;
  }
  if (contract && company && selectedPhase) {
    return (
      <CompanyPhaseChangeForm
        contract={contract}
        company={company}
        selectedPhase={selectedPhase}
        onCancel={onCancel}
      />
    );
  }
  return <></>;
};

export default EditPhaseFormDisplay;
